import { render, staticRenderFns } from "./PredictedScore.vue?vue&type=template&id=b7080088&scoped=true&lang=pug&"
import script from "./PredictedScore.vue?vue&type=script&lang=ts&"
export * from "./PredictedScore.vue?vue&type=script&lang=ts&"
import style0 from "./PredictedScore.vue?vue&type=style&index=0&id=b7080088&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7080088",
  null
  
)

export default component.exports